export default (fill) => (
  `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 137.2">
    <path fill="#D0E0E1" d="M0 12.5C0 5.6 5.6 0 12.5 0h54L100 34.1l-.3 90.7c0 6.9-5.6 12.5-12.5 12.5H12.5c-6.9 0-12.5-5.6-12.5-12.5V12.5z"/>
    <g fill="#6D7577">
        <path d="M32.2 113.4l-5.6-20.7h-.1l-5.7 20.7h-3.4l-6.3-24.6h3.3l4.8 20.5h.1l5.5-20.5h3.5l5.4 20.5h.1l5-20.5h3.3l-6.6 24.6h-3.3zM54.7 88.8l9.6 24.6h-3.6L58 106H47.6l-2.8 7.4h-3.3l9.6-24.6h3.6zm2.3 14.5l-4.1-11.5h-.1l-4.2 11.5H57zM71.1 113.4l-8.6-24.6H66l7 21.3h.1l7.1-21.3h3.4l-8.8 24.6h-3.7z"/>
    </g>
    <path fill="${fill? fill : '#A1AFAF'}" d="M66.5 0v34.1H100L66.5 0z"/>
</svg>`
)


// WEBPACK FOOTER //
// ./components/Icon/icons/files/wav.jsx